import appconst from './appconst'
export const I18N = function (value: string, source?: string, ...argus: string[]): string {

    const lan = abp.utils.getCookieValue('Abp.Localization.CultureName')
    // console.log('Abp.Localization.CultureName', lan)	
    // 以名称搜当前对象
	if(source){
	    return window.abp.localization.localize(value,source,argus);
	}else{
	    return window.abp.localization.localize(value,appconst.localization.defaultLocalizationSourceName,argus);
	}
}

export const changeLan =  function (language: string) {
    abp.utils.setCookieValue(
        "Abp.Localization.CultureName",
        language,
        new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
        abp.appPath
    );
    location.reload();
}
